<template>
  <v-card-text class="pa-0 ma-0 text-caption">
    <number-input v-if="type==='number'" :hide-details="!errorMessage" :error-message="errorMessage" :label="label"
                  :type="subtype"
                  :value="$utils.isNullOrUndefined(valueToAdd)? undefined : Number(valueToAdd)"
                  @input="valueToAdd = $event" @keyup.enter="onAdd" @blur="onAdd(); $emit('blur', $event)"
    >
      <template #append v-if="canAdd">
        <v-btn variant="text" icon size="x-small" @click="onAdd">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </number-input>
    <v-text-field v-else hide-details :label="label" v-model="valueToAdd"
                  :type="type === 'date'? 'date':undefined"
                  @keyup.enter.tab="onAdd" @keydown.tab="onAdd" @blur="onAdd">
      <template #append v-if="canAdd">
        <v-btn variant="text" icon size="x-small" @click="onAdd">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <v-chip-group column v-model="selection"
    >
      <!-- Os valores são simples (texto, número), sem campo de id: a chave é o próprio
           valor. O índice, que era a chave antes, o vuedraggable 4 não entrega ao item-key. -->
      <draggable v-model="elements" :item-key="element => element" @start="dragStart" @end="dragEnd">
        <template #item="{ element, index: i }">
          <v-chip size="small" draggable :class="{'bg-primary': i === draggedIndex}"
                  closable
                  @click:close="elements.splice(i,1); $emit('input', elements)">
            {{ element }}
          </v-chip>
        </template>
      </draggable>
    </v-chip-group>
  </v-card-text>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import Draggable from "vuedraggable"
import NumberInput from "@/components/shared/NumberInput.vue"

@Component({emits: ['blur', 'input'], components: {NumberInput, Draggable}})
class MultipleField extends Vue {
  @Prop({type: Array}) value!: any[]
  @Prop({type: String}) label!: string
  @Prop({type: String}) type!: string
  @Prop({type: String}) subtype!: string
  @Prop({type: String}) errorMessage!: string

  selection: number | null = null
  currentElement: any = null
  valueToAdd: any = null
  draggedIndex: number | null = null

  get elements(): any[] {
    return this.value
  }

  set elements(elements: any[]) {
    this.$emit('input', elements)
  }

  get canAdd(): boolean {
    return !this.$utils.isNullOrUndefined(this.valueToAdd) && ('' + this.valueToAdd).trim() !== ""
  }

  dragStart(event: any) {
    this.draggedIndex = event.oldIndex
  }

  dragEnd() {
    this.draggedIndex = null
  }

  onAdd() {
    if (this.canAdd) {
      this.elements.push(this.valueToAdd)
      this.valueToAdd = null
      this.$emit('input', this.elements)
    }
  }
}

export default toNative(MultipleField)
</script>
<style>

.v-chip {
  height: auto !important;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>